import * as React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { BrowserRouter as Router, Route } from "react-router-dom"
import { addAjaxEnricher, configure, ConnectedRouter, store } from "@bapp/webcore"
import BappUiProvider, { Platforms } from "@bappweb/provider"
import Main from "./pages"
import rootReducers from "./states/root"
import logMiddleware from "./states/middleware/logMiddleware"
import setupAxiosInterceptors from "./config/axios"
import ajaxEnricher from "./config/enricher"
import "./i18n"
import "@bappweb/provider/styles.css"
import "@bappweb/provider/sass/bapp-reboot.scss"
import "./assets/styles/style.scss"

const App = () => {
  return (
    <Provider store={store}>
      <BappUiProvider theme="theme-default" platform={Platforms.Desktop}>
        <ConnectedRouter store={store}>
          <Router>
            <Route component={Main} />
          </Router>
        </ConnectedRouter>
      </BappUiProvider>
    </Provider>
  )
}

setupAxiosInterceptors()
addAjaxEnricher(ajaxEnricher)
configure(rootReducers, [logMiddleware])

ReactDOM.render(<App />, document.getElementById("root"))
